import React from 'react';

export const PricingGuide = () => (
  <div className="w-full max-w-md mt-3 sm:mt-4 p-3 sm:p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
    <h4 className="text-xs sm:text-sm font-bold text-gray-800 mb-2 sm:mb-3 flex items-center gap-2">
      <svg className="w-3 h-3 sm:w-4 sm:h-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Pricing Guide
    </h4>
    <div className="space-y-2 text-xs">
      <div className="flex justify-between text-gray-600">
        <span>Gildan 5000 Classic Tee</span>
        <span className="font-semibold">$22.99</span>
      </div>
      <div className="border-t border-blue-200 pt-1.5 sm:pt-2 mt-1.5 sm:mt-2">
        <p className="text-gray-500 font-medium mb-0.5 sm:mb-1">Print Add-ons:</p>
        <div className="flex justify-between text-gray-600 pl-2">
          <span>Front Print</span>
          <span>+$4.00</span>
        </div>
        <div className="flex justify-between text-gray-600 pl-2">
          <span>Back Print</span>
          <span>+$4.00</span>
        </div>
        <div className="flex justify-between text-gray-600 pl-2">
          <span>Sleeve (each)</span>
          <span>+$3.00</span>
        </div>
      </div>
      <div className="border-t border-blue-200 pt-1.5 sm:pt-2 mt-1.5 sm:mt-2">
        <div className="flex justify-between text-gray-600">
          <span>Shipping</span>
          <span>$9.99</span>
        </div>
      </div>
      <div className="border-t border-green-200 pt-1.5 sm:pt-2 mt-1.5 sm:mt-2 bg-green-50/50 rounded p-1.5">
        <p className="text-green-700 font-semibold mb-0.5">Bundle & Save!</p>
        <div className="text-green-600 pl-1">
          <p>2+ shirts = FREE shipping</p>
          <p>3+ shirts = 15% off</p>
        </div>
      </div>
    </div>
  </div>
);

export default PricingGuide;
